import { instance as axios } from '../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorHandler } from '../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';
import { RptOptionPersonalLedgerView , UserList ,
         PerformancePersonalLedgerView, RptPerformancePersonalLedgerView , AwardNosDetail ,
         RptPspMasterShareView , PerformancePlanDetail , RptPspAwardSummaryView ,
         RptPspVestingView , RptPspAllotmentView , RptUserDetailView ,
         RptLapseESOPView , RptLapsePSPView , RptGainsView , RptPspFairValue , 
         SavePSPFairValue , RptPSPAmortization , SavePSPAmortization } from 'src/models/reportModel';
import { VestingMaster } from 'src/models/acceptofferDetail';

//================|| PSP REPORTS ||=================//
type pspReportsState = {
    loading: boolean;
    error: ErrorInformation;
    userList: UserList[];
    vestingMaster: VestingMaster;
    performancePersonalLedgerView: PerformancePersonalLedgerView;
    rptPerformancePersonalLedgerView: RptPerformancePersonalLedgerView;
    awardNosDetail: AwardNosDetail[];
    rptPspMasterShareView: RptPspMasterShareView[];
    performancePlanDetail: PerformancePlanDetail[];
    rptPspAwardSummaryView: RptPspAwardSummaryView[];
    rptPspVestingView: RptPspVestingView[];
    rptPspAllotmentView: RptPspAllotmentView[];
    AllotmentString: string;
    rptUserDetailView: RptUserDetailView[];
    rptLapseESOPView: RptLapseESOPView[];
    rptLapsePSPView: RptLapsePSPView[];
    rptGainsView: RptGainsView[];
    rptPspFairValue: RptPspFairValue[];
    SaveResponse: string;
    rptPSPAmortization: RptPSPAmortization;
    CostCenterString: string;
}

type GrantNoAndID = {
    grantNo: string,
    userID: string
}

type userNameanduserID = {
    searchUserID: string,
    searchName: string,
}

type userIDandPlanID = {
    userID: string,
    PlanID: number,
}

type fromtoStatusID = {
    fromStatusID: number,
    toStatusID: number,
}

type awardSummaryParams = {
    fromDate: string,
    toDate: string,
    planID: number,
}

type awardNoListandemploymentStatusList = {
    awardNoList: string,
    employmentStatusList: string,
}

type vestingParams = {
    vestingDateFrom: string,
    vestingDateTo: string,
    isShare: boolean,
    planID: number,
}

type allotmentParams = {
    fromDate: string,
    endDate: string,
}

type lapseParams = {
    lapseDateFrom: string,
    lapseDateTo: string,
}

type employmentStatusList = {
    employmentStatusList: string,
}

type gainsParams = {
    fromDate: string,
    toDate: string,
    planType: string,
}

type AmortizeParams = {
    awardDateFrom: string,
    awardDateTo: string,
    schedulePeriodFrom: string,
    schedulePeriodTo: string,
    planID: number,
    isShare: boolean,
}

type costcenterParams = {
    schedulePeriodFrom: string,
    schedulePeriodTo: string,
    planID: number,
    isShare: boolean,
}

const initialState: pspReportsState = {
    loading: false,
    error: null,
    userList: [],
    vestingMaster: null ,
    performancePersonalLedgerView: {
        planModels: [],
        fullName: '',
        nric: '',
    },
    rptPerformancePersonalLedgerView: null,
    awardNosDetail: [],
    rptPspMasterShareView: [],
    performancePlanDetail: [],
    rptPspAwardSummaryView: [],
    rptPspVestingView : [],
    rptPspAllotmentView: [],
    AllotmentString: '',
    rptUserDetailView: [],
    rptLapseESOPView: [],
    rptLapsePSPView: [],
    rptGainsView: [],
    rptPspFairValue: [],
    SaveResponse: '',
    rptPSPAmortization: {
        amortizeSchedule: [],
        lapseDetails: [],
        amortizePeriod: [],
    },
    CostCenterString: '',
};

export const getUserList = createAsyncThunk(
    "pspReports/getUserList",
    async (userNameanduserID: userNameanduserID, { rejectWithValue }) => {
        try {
            if(userNameanduserID.searchUserID.toString() != '' && 
            userNameanduserID.searchName.toString() != '') {
                const getUserListOption = await axios.get<string>(`Profile/getSearchUser?searchUserID=${userNameanduserID.searchUserID.toString()}&searchName=${userNameanduserID.searchName.toString()}`)
                return getUserListOption.data
            }
            else if(userNameanduserID.searchUserID.toString() != '') {
                const getUserListOption = await axios.get<string>(`Profile/getSearchUser?searchUserID=${userNameanduserID.searchUserID.toString()}`)
                return getUserListOption.data
            }
            else if(userNameanduserID.searchName.toString() != '') {
                const getUserListOption = await axios.get<string>(`Profile/getSearchUser?searchName=${userNameanduserID.searchName.toString()}`)
                return getUserListOption.data
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getPerformancePersonalLedgerView = createAsyncThunk<PerformancePersonalLedgerView, {}, { rejectValue: ErrorInformation }>(
    "pspReports/getPerformancePersonalLedgerView",
    async (userID: string, { rejectWithValue }) => {
        try {
            const getPerformancePersonalLedgerViewResponse = await axios.get<PerformancePersonalLedgerView>(`ReportService/getPerformancePersonalLedgerView?userID=${userID}`);
            return getPerformancePersonalLedgerViewResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getPerformancePersonalLedger = createAsyncThunk(
    "pspReports/getPerformancePersonalLedger",
    async (params: userIDandPlanID, { rejectWithValue }) => {
        try {
            const getPerformancePersonalLedgerResponse = await axios.get<RptOptionPersonalLedgerView>(`ReportService/getPerformancePersonalLedger?userID=${params.userID}&PlanID=${params.PlanID}`)
            return getPerformancePersonalLedgerResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getVestingSchedule = createAsyncThunk(
    "pspReports/getVestingSchedule",
    async (grantNoAndID: GrantNoAndID, { rejectWithValue }) => {
        try {
            const getVestingScheduleResponse = await axios.get<VestingMaster>(`ReportService/getOptionVestingSchedule?GrantNo=${grantNoAndID.grantNo}&GrantUserID=${grantNoAndID.userID}`)
            return getVestingScheduleResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

// PSP Master Share Report

export const performanceAwardNo = createAsyncThunk(
    "pspReports/performanceAwardNo",
    async (fromtoStatusID: fromtoStatusID, { rejectWithValue }) => {
        try {
            const getGrantNoResponse = await axios.get<AwardNosDetail>(`PspMisc/performanceAwardNo?FromStatusID=${fromtoStatusID.fromStatusID}&ToStatusID=${fromtoStatusID.toStatusID}`)
            return getGrantNoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getPerformanceMasterShareDetails = createAsyncThunk(
    "pspReports/getPerformanceMasterShareDetails",
    async (params: awardNoListandemploymentStatusList, { rejectWithValue }) => {
        try {
            const getPerformanceMasterShareDetailsResponse = await axios.get<RptPspMasterShareView>(`ReportService/getPerformanceMasterShareDetails?awardNoList=${params.awardNoList}&employmentStatusList=${params.employmentStatusList}`)
            return getPerformanceMasterShareDetailsResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

// PSP Award Summary Report

export const getPerformanceSharePlan = createAsyncThunk<PerformancePlanDetail, {}, { rejectValue: ErrorInformation }>(
    "pspReports/getPerformanceSharePlan",
    async ({ }, { rejectWithValue }) => {
        try {
            const getPerformanceSharePlanResponse = await axios.get<PerformancePlanDetail>('PspMisc/getPerformanceSharePlan')
            return getPerformanceSharePlanResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPerformanceAwardSummary = createAsyncThunk(
    "pspReports/getPerformanceAwardSummary",
    async (Params: awardSummaryParams, { rejectWithValue }) => {
        try {
            const getPerformanceAwardSummaryResponse:any= await axios.get<RptPspAwardSummaryView>(`ReportService/getPerformanceAwardSummary?fromDate=${Params.fromDate}&toDate=${Params.toDate}&planID=${Params.planID}`)
            return getPerformanceAwardSummaryResponse.data.awardSummaries
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

// PSP Vesting Report

export const getPerformanceVesting = createAsyncThunk(
    "pspReports/getPerformanceVesting",
    async (Params: vestingParams, { rejectWithValue }) => {
        try {
            const getPerformanceVestingResponse = await axios.get<RptPspVestingView>(`ReportService/getPerformanceVesting?vestingDateFrom=${Params.vestingDateFrom}&vestingDateTo=${Params.vestingDateTo}&isShare=${Params.isShare}&planID=${Params.planID}`)
            return getPerformanceVestingResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

// PSP Allotment Report

export const getPerformanceCreditingProcessByDate = createAsyncThunk(
    "pspReports/getPerformanceCreditingProcessByDate",
    async (Params: allotmentParams, { rejectWithValue }) => {
        try {
            const getPerformanceCreditingProcessByDateResponse = await axios.get<RptPspAllotmentView>(`PSP/getPerformanceCreditingProcessByDate?fromDate=${Params.fromDate}&endDate=${Params.endDate}&isSubmitted=true`)
            return getPerformanceCreditingProcessByDateResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const GenerateReport = createAsyncThunk(
    "pspReports/GenerateReport",
    async (batchNo: number, { rejectWithValue }) => {
        try {
            const GenerateReportResponse = await axios.get<string>(`PSP/GenerateReport?batchNo=${batchNo}`)
            return GenerateReportResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

// PSP Expense Report

// Enter Fair Value

export const getPerformanceFairValue = createAsyncThunk(
    "pspReports/getPerformanceFairValue",
    async (params: allotmentParams, { rejectWithValue }) => {
        try {
            const getPerformanceFairValueResponse = await axios.get<RptPspFairValue>(`ReportService/getPerformanceFairValue?vestingDateFrom=${params.fromDate}&vestingDateTo=${params.endDate}`)
            return getPerformanceFairValueResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const setPerformanceFairValue = createAsyncThunk<number, { awardInfo: SavePSPFairValue }, { rejectValue: ErrorInformation }>(
    "pspReports/setPerformanceFairValue",
    async ({awardInfo}, { rejectWithValue }) => {
        try {
            const response = await axios.post('/ReportService/setPerformanceFairValue', awardInfo)
            return response.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

// Amortization Report

export const getPerformanceAmortizeSchedule = createAsyncThunk(
    "pspReports/getPerformanceAmortizeSchedule",
    async (params: AmortizeParams, { rejectWithValue }) => {
        try {
            const getAmortizeScheduleResponse = await axios.get<RptPSPAmortization>(`ReportService/getPerformanceAmortizeSchedule?awardDateFrom=${params.awardDateFrom}&awardDateTo=${params.awardDateTo}
                &schedulePeriodFrom=${params.schedulePeriodFrom}&schedulePeriodTo=${params.schedulePeriodTo}&planID=${params.planID}&isShare=${params.isShare}`)
            return getAmortizeScheduleResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const setPerformanceAmortizeSchedule = createAsyncThunk<number, { Info: SavePSPAmortization }, { rejectValue: ErrorInformation }>(
    "pspReports/setPerformanceAmortizeSchedule",
    async ({Info}, { rejectWithValue }) => {
        try {
            const response = await axios.post('ReportService/setPerformanceAmortizeSchedule', Info)
            return response.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

// Cost Center Report

export const getPerformanceCostCenterReport = createAsyncThunk(
    "pspReports/getPerformanceCostCenterReport",
    async (params: costcenterParams, { rejectWithValue }) => {
        try {
            const getPerformanceCostCenterReportResponse = await axios.get<RptPSPAmortization>(`ReportService/getPerformanceCostCenterReport?schedulePeriodFrom=${params.schedulePeriodFrom}
                &schedulePeriodTo=${params.schedulePeriodTo}&planID=${params.planID}&isShare=${params.isShare}`)
            return getPerformanceCostCenterReportResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

// User Details

export const getUserDetailsReport = createAsyncThunk(
    "pspReports/getUserDetailsReport",
    async (params: employmentStatusList, { rejectWithValue }) => {
        try {
            const getUserDetailsReportResponse = await axios.get<RptUserDetailView>(`ReportService/getUserDetailsReport?employmentStatusList=${params.employmentStatusList}`)
            return getUserDetailsReportResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

// PSP Lapse Report

export const getEsopLapseReport = createAsyncThunk(
    "pspReports/getEsopLapseReport",
    async (Params: lapseParams, { rejectWithValue }) => {
        try {
            const getEsopLapseReportResponse = await axios.get<RptLapseESOPView>(`ReportService/getEsopLapseReport?lapseDateFrom=${Params.lapseDateFrom}&lapseDateTo=${Params.lapseDateTo}`)
            return getEsopLapseReportResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getPerformanceLapseReport = createAsyncThunk(
    "pspReports/getPerformanceLapseReport",
    async (Params: lapseParams, { rejectWithValue }) => {
        try {
            const getPerformanceLapseReportResponse = await axios.get<RptLapsePSPView>(`ReportService/getPerformanceLapseReport?lapseDateFrom=${Params.lapseDateFrom}&lapseDateTo=${Params.lapseDateTo}`)
            return getPerformanceLapseReportResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

// PSP Gains Report

export const getGainsReport = createAsyncThunk(
    "pspReports/getGainsReport",
    async (Params: gainsParams, { rejectWithValue }) => {
        try {
            const getGainsReportResponse = await axios.get<RptGainsView>(`ReportService/getGainsReport?fromDate=${Params.fromDate}&toDate=${Params.toDate}&planType=${Params.planType}`)
            return getGainsReportResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

const pspReportsSlice = createSlice({
    name: 'pspReports',
    initialState,
    reducers: {},
    extraReducers: {
        
        //get User List View
        [getUserList.pending.type]: (state) => {
            state.loading = true;
        },
        [getUserList.fulfilled.type]: (state, action) => {
            state.userList = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getUserList.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Option Personal Ledger View
        [getPerformancePersonalLedgerView.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformancePersonalLedgerView.fulfilled.type]: (state, action) => {
            state.performancePersonalLedgerView = action.payload;
            state.loading = false;
        },
        [getPerformancePersonalLedgerView.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        //get Vesting Schedule
        [getVestingSchedule.pending.type]: (state) => {
            state.loading = true;
        },
        [getVestingSchedule.fulfilled.type]: (state, action) => {
            state.vestingMaster = action.payload;
            state.loading = false;
        },
        [getVestingSchedule.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Rpt Performance Personal Ledger View
        [getPerformancePersonalLedger.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformancePersonalLedger.fulfilled.type]: (state, action) => {
            state.rptPerformancePersonalLedgerView = action.payload;
            state.loading = false;
        },
        [getPerformancePersonalLedger.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //PSP Master Share Report
        //get Award No
        [performanceAwardNo.pending.type]: (state) => {
            state.loading = true;
        },
        [performanceAwardNo.fulfilled.type]: (state, action) => {
            state.awardNosDetail = action.payload;
            state.loading = false;
            state.error = null;
        },
        [performanceAwardNo.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Master Share Details
        [getPerformanceMasterShareDetails.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceMasterShareDetails.fulfilled.type]: (state, action) => {
            state.rptPspMasterShareView = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getPerformanceMasterShareDetails.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //PSP Award Summary Report
        //get Performance Award Details
        [getPerformanceSharePlan.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceSharePlan.fulfilled.type]: (state, action) => {
            state.performancePlanDetail = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getPerformanceSharePlan.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Award Summary Details
        [getPerformanceAwardSummary.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceAwardSummary.fulfilled.type]: (state, action) => {
            state.rptPspAwardSummaryView = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getPerformanceAwardSummary.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //PSP Vesting Report
        //get Vesting Details
        [getPerformanceVesting.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceVesting.fulfilled.type]: (state, action) => {
            state.rptPspVestingView = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getPerformanceVesting.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //PSP Allotment Report
        //get Allotment Details
        [getPerformanceCreditingProcessByDate.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceCreditingProcessByDate.fulfilled.type]: (state, action) => {
            state.rptPspAllotmentView = action.payload;
            state.loading = false;
        },
        [getPerformanceCreditingProcessByDate.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Allotment Report for Batch No.
        [GenerateReport.pending.type]: (state) => {
            state.loading = true;
        },
        [GenerateReport.fulfilled.type]: (state, action) => {
            state.AllotmentString = action.payload;
            state.loading = false;
        },
        [GenerateReport.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //PSP Expense Report
        //get PSP Expense Report 
        [getPerformanceFairValue.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceFairValue.fulfilled.type]: (state, action) => {
            state.rptPspFairValue = action.payload;
            state.loading = false;
        },
        [getPerformanceFairValue.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // Save Enter fair value
        [setPerformanceFairValue.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceFairValue.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setPerformanceFairValue.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Amortization value
        [getPerformanceAmortizeSchedule.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceAmortizeSchedule.fulfilled.type]: (state, action) => {
            state.rptPSPAmortization = action.payload;
            state.loading = false;
        },
        [getPerformanceAmortizeSchedule.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Save Amortization
        [setPerformanceAmortizeSchedule.pending.type]: (state) => {
            state.loading = true;
        },
        [setPerformanceAmortizeSchedule.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setPerformanceAmortizeSchedule.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },


        //get Cost Center
        [getPerformanceCostCenterReport.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceCostCenterReport.fulfilled.type]: (state, action) => {
            state.CostCenterString = action.payload;
            state.loading = false;
        },
        [getPerformanceCostCenterReport.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //User Details
        //get User Details
        [getUserDetailsReport.pending.type]: (state) => {
            state.loading = true;
        },
        [getUserDetailsReport.fulfilled.type]: (state, action) => {
            state.rptUserDetailView = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getUserDetailsReport.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //Lapse Report
        //get ESOP Lapse Details
        [getEsopLapseReport.pending.type]: (state) => {
            state.loading = true;
        },
        [getEsopLapseReport.fulfilled.type]: (state, action) => {
            state.rptLapseESOPView = action.payload;
            state.loading = false;
        },
        [getEsopLapseReport.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get PSP Lapse Details
        [getPerformanceLapseReport.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceLapseReport.fulfilled.type]: (state, action) => {
            state.rptLapsePSPView = action.payload;
            state.loading = false;
        },
        [getPerformanceLapseReport.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //Gains Report
        //get Gains Details
        [getGainsReport.pending.type]: (state) => {
            state.loading = true;
        },
        [getGainsReport.fulfilled.type]: (state, action) => {
            state.rptGainsView = action.payload;
            state.loading = false;
        },
        [getGainsReport.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
    }
})
export default pspReportsSlice